<figure [id]="chartId" class="m-0 d-flex justify-content-center align-items-center" style="position:relative">
    <div [ngStyle]="getDivStyle()" class="progress-indicator">
        <img width="12" class="alarmicon"
            [src]="chartId === 'alarm-operator-ratio-alarm' ? '../../assets/images/Alarm.svg' :'../../assets/images/operator.svg'" />
    </div>
</figure>